import { Component, inject } from '@angular/core';
import { MainTruckHistoricService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MainTruckHistoricCreateDto,
  MainTruckHistoricDto,
  MainTruckHistoricExcelDownloadDto,
  MainTruckHistoricUpdateDto,
} from '../proxy/general/dtos/main-truck-historic';
import { MAINTRUCKHISTORIC_CONFIG, MAINTRUCKHISTORIC_FIELDS } from './main-truck-historic.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-main-truck-historic',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MainTruckHistoricService, ConfirmationService],
  templateUrl: './main-truck-historic.html',
  styleUrl: './main-truck-historic.scss',
})
export class MainTruckHistoric extends BaseCrudComponent<
  MainTruckHistoricDto,
  MainTruckHistoricCreateDto,
  MainTruckHistoricUpdateDto,
  MainTruckHistoricExcelDownloadDto
> {
  service = inject(MainTruckHistoricService);
  config = MAINTRUCKHISTORIC_CONFIG;
  fields = MAINTRUCKHISTORIC_FIELDS;

  protected prepareUpdateDto(data: any, selected: MainTruckHistoricDto): MainTruckHistoricUpdateDto {
    return {
      isMainTruck: data.isMainTruck,
      validSince: data.validSince,
      vehicleId: data.vehicleId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MainTruckHistoric';
  }
}
